import { render } from "./TdStatus.vue?vue&type=template&id=38ddf9b0"
import script from "./TdStatus.vue?vue&type=script&lang=js"
export * from "./TdStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Adewale\\OneDrive - kochind.com\\Documents\\zoloscan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__